import React from 'react';
import { useState, useLayoutEffect } from "react";
import PropTypes from 'prop-types';
import longhorizontal from '../../assets/longhorizontal.svg';
import longvertical from "../../assets/longvertical.svg"
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import "./style.css";

let totalWeight;

function getQuadData(quadrant) {
  return [{}]
}

export const DropDownTable = (props) => {
  const [loading, setLoading] = useState(true);
  const [isImperial] =useState(props.isImperial);
  console.log("hit dropdowntable");

  totalWeight=Number(props.totalWeight)+1720;
  if(isImperial)
    totalWeight=totalWeight+" lb"
  else
    totalWeight=totalWeight+" kg"
  const [dataRows, setDataRows] = useState(props.rows);


  function createData(quadrant, quadData1, quadData2, quadData3, quadData4) {
    return {
      quadrant,
      quadData1,
      quadData2,
      quadData3,
      quadData4
    };
  }
  

  function Row(props) {
    const { row } = props;
  
    console.log(row)
    const [open, setOpen] = useState(false);
    function roationImage(width, length){
      const numericWidth = parseFloat(width);
      const numericLength = parseFloat(length);
      if (numericWidth>=numericLength){
        return(<img src={longhorizontal} className="checkmark" alt="check" width="20px" height="20px"/>)
      }
      else{
        return(<img src={longvertical} className="checkmark" alt="check" width="20" height="20"/>)
  
      }
    }
  
    return (
      <React.Fragment>
        <TableRow sx={{ '& > *': { borderBottom: 'unset', backgroundColor: "#F5F5F5" } }}>
          <TableCell component="th" scope="row" align='left' width='90%' padding='6px 24px'>
            {row.quadrant}
          </TableCell>
          <TableCell sx={{}}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {setOpen(!open);}}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box overflow="auto" sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>NSN</TableCell>
                      <TableCell>NIIN</TableCell>
                      <TableCell>Nomenclature</TableCell>
                      <TableCell align="center">Position<br />Order</TableCell>
                      <TableCell align="center">Longest Side<br />Direction</TableCell>
                      <TableCell align="center">Vertical<br />Level</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.quadData1.map((quadDataRow) => (
                      <TableRow key={quadDataRow.date}>
                        <TableCell component="th" scope="row">
                          {quadDataRow.nsn}
                        </TableCell>
                        <TableCell>{quadDataRow.niin}</TableCell>
                        <TableCell>{quadDataRow.nomenclature}</TableCell>
                        <TableCell>{quadDataRow.position_no}</TableCell>
                        <TableCell>{roationImage(quadDataRow.width, quadDataRow.length)}</TableCell>
                        <TableCell>{quadDataRow.level}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  
  let q1=[];
  let q2=[];
  let q3=[];
  let q4=[];
  let hasParse=false;
  function reorderList(list){
    parseList(list.sort((a, b) => a.position_no - b.position_no));
  }
  function parseList(list){
    console.log("list:"+ JSON.stringify(list) );
    if (!hasParse){
      list.map((val,index)=>{
        //console.log(val);
        //console.log("val.quadid: "+val.quadid)
        if(val.quadid===1){q1.push(val);        }
        if(val.quadid===2){q2.push(val);}
        if(val.quadid===3){q3.push(val);}
        if(val.quadid===4){q4.push(val);} 
        hasParse=true;
        //console.log("true, q1 : "+ JSON.stringify(q1[0])) 
      })
    }
  }
  
  let rows = [
    createData('Quadrant Alpha', q1),
    createData('Quadrant Bravo', q2),
    createData('Quadrant Charlie', q3),
    createData('Quadrant Delta', q4),
  ];
  
  if (dataRows){
    reorderList(dataRows);
  }
  else {
    setLoading(true)
  }

  useLayoutEffect(() => {
  }, [dataRows])
  return (
    <TableContainer sx={{ maxHeight: 400, overflow: "auto", position: "sticky", width: 675, display: 'flex' }} component={Paper}>
      <Table stickyHeader="true" overflow="scroll" aria-label="collapsible table' className='dropDownTable" overflowY="scroll">
        <TableBody>
          {rows.map((row) => (
            <Row key={row.quadrant} row={row} />
          ))}
          <TableRow>
            <TableCell
              component="th"
              scope="row"
              align="left"
              width="80%"
              padding="6px 24px"
            >
              ISU Total Weight (with container):
            </TableCell>
            <TableCell component="th" scope="row" align="right">
              {totalWeight}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default DropDownTable;